var objectSetPrototypeOf = require('../internals/object-set-prototype-of');
var validateSetPrototypeOfArguments = require('../internals/validate-set-prototype-of-arguments');

// `Reflect.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-reflect.setprototypeof
if (objectSetPrototypeOf) require('../internals/export')({ target: 'Reflect', stat: true }, {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    validateSetPrototypeOfArguments(target, proto);
    try {
      objectSetPrototypeOf(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es.reflect.set-prototype-of.js
// module id = 220
// module chunks = 0